__turbopack_context__.v({
  "consumerCardsContainer": "ConsumerCards-module-scss-module__0lT5gG__consumerCardsContainer",
});
